var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"text-h6 font-weight-medium"},[_vm._v(_vm._s(_vm.$t("dashboard.title")))]),_c('div',{staticClass:"text-body-2 grey--text"},[_vm._v("BulkSMS")])]),_c('bulksms-statistic')],1)}
var staticRenderFns = []

export { render, staticRenderFns }